import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pickup',
  templateUrl: './pickup.component.html',
  styleUrls: ['./pickup.component.scss'],
  standalone: false
})
export class PickupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
